module.exports = __webpack_public_path__ + "img/double.42a081d.svg";